export default __webpack_public_path__ + "72cea104d7d508052beeab739fff9187.png";